import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import appReducer from '../reducers';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: [
        'AEMContentReducer',
        'appReducer',
        'dynamicLandingReducer',
        'recommendationReducer',
    ], // which reducer want to store
};

const composeEnhancers =
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
        : compose;

const pReducer = persistReducer(persistConfig, appReducer);
const middleware = composeEnhancers(applyMiddleware(thunk));
const store = createStore(pReducer, middleware);
const persistor = persistStore(store);
export { persistor, store };
